import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { MenuIcon, XIcon, ChevronDownIcon, ChevronUpIcon } from 'lucide-react';
const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isPoliciesOpen, setIsPoliciesOpen] = useState(false);
  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };
  const togglePolicies = () => {
    setIsPoliciesOpen(!isPoliciesOpen);
  };
  return <header className="bg-white shadow-sm sticky top-0 z-50" data-id="element-74">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-75">
        <Link to="/" className="flex items-center" data-id="element-76">
          <div className="text-2xl font-bold" data-id="element-77">
            <span className="text-[#1A2B4C]" data-id="element-78">Elevate</span>
            <span className="text-[#1FC5A8]" data-id="element-79">fix</span>
          </div>
        </Link>
        {/* Desktop Navigation */}
        <nav className="hidden md:flex space-x-8" data-id="element-80">
          <Link to="/" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" data-id="element-81">
            Home
          </Link>
          <Link to="/service-coverage" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" data-id="element-82">
            Service Coverage
          </Link>
          <Link to="/about" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" data-id="element-83">
            About Us
          </Link>
          <Link to="/faqs" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" data-id="element-84">
            FAQs
          </Link>
          <div className="relative group" data-id="element-85">
            <button className="flex items-center text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={togglePolicies} data-id="element-86">
              Policies
              {isPoliciesOpen ? <ChevronUpIcon size={16} className="ml-1" data-id="element-87" /> : <ChevronDownIcon size={16} className="ml-1" data-id="element-88" />}
            </button>
            {isPoliciesOpen && <div className="absolute left-0 mt-2 w-56 bg-white rounded-md shadow-lg py-2 z-20" data-id="element-89">
                <Link to="/cancellation-policy" className="block px-4 py-2 text-[#1A2B4C] hover:text-[#1FC5A8] hover:bg-gray-50" onClick={() => setIsPoliciesOpen(false)} data-id="element-90">
                  Cancellation Policy
                </Link>
                <Link to="/refund-policy" className="block px-4 py-2 text-[#1A2B4C] hover:text-[#1FC5A8] hover:bg-gray-50" onClick={() => setIsPoliciesOpen(false)} data-id="element-91">
                  Refund Policy
                </Link>
                <Link to="/privacy-policy" className="block px-4 py-2 text-[#1A2B4C] hover:text-[#1FC5A8] hover:bg-gray-50" onClick={() => setIsPoliciesOpen(false)} data-id="element-92">
                  Privacy & Cookie Policy
                </Link>
                <Link to="/terms" className="block px-4 py-2 text-[#1A2B4C] hover:text-[#1FC5A8] hover:bg-gray-50" onClick={() => setIsPoliciesOpen(false)} data-id="element-93">
                  Terms & Conditions
                </Link>
              </div>}
          </div>
          <Link to="/contact" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" data-id="element-94">
            Contact Us
          </Link>
        </nav>
        {/* Mobile Menu Button */}
        <button className="md:hidden text-[#1A2B4C]" onClick={toggleMenu} aria-label="Toggle menu" data-id="element-95">
          {isMenuOpen ? <XIcon size={24} data-id="element-96" /> : <MenuIcon size={24} data-id="element-97" />}
        </button>
      </div>
      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white px-4 py-2 shadow-md" data-id="element-98">
          <nav className="flex flex-col space-y-4 pb-4" data-id="element-99">
            <Link to="/" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-100">
              Home
            </Link>
            <Link to="/service-coverage" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-101">
              Service Coverage
            </Link>
            <Link to="/about" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-102">
              About Us
            </Link>
            <Link to="/faqs" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-103">
              FAQs
            </Link>
            <div data-id="element-104">
              <button className="flex items-center text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors w-full text-left" onClick={togglePolicies} data-id="element-105">
                Policies
                {isPoliciesOpen ? <ChevronUpIcon size={16} className="ml-1" data-id="element-106" /> : <ChevronDownIcon size={16} className="ml-1" data-id="element-107" />}
              </button>
              {isPoliciesOpen && <div className="pl-4 mt-2 space-y-2" data-id="element-108">
                  <Link to="/cancellation-policy" className="block text-[#1A2B4C] hover:text-[#1FC5A8]" onClick={() => setIsMenuOpen(false)} data-id="element-109">
                    Cancellation Policy
                  </Link>
                  <Link to="/refund-policy" className="block text-[#1A2B4C] hover:text-[#1FC5A8]" onClick={() => setIsMenuOpen(false)} data-id="element-110">
                    Refund Policy
                  </Link>
                  <Link to="/privacy-policy" className="block text-[#1A2B4C] hover:text-[#1FC5A8]" onClick={() => setIsMenuOpen(false)} data-id="element-111">
                    Privacy & Cookie Policy
                  </Link>
                  <Link to="/terms" className="block text-[#1A2B4C] hover:text-[#1FC5A8]" onClick={() => setIsMenuOpen(false)} data-id="element-112">
                    Terms & Conditions
                  </Link>
                </div>}
            </div>
            <Link to="/contact" className="text-[#1A2B4C] hover:text-[#1FC5A8] font-medium transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-113">
              Contact Us
            </Link>
          </nav>
        </div>}
    </header>;
};
export default Header;